/**
 * The shapes a post is made in, as the wizard names them. A post keeps its shape as the first
 * words of its brief (the shape's brief text), so it can be read back off any post later: on
 * Home, to say what kind of post reached people, and to make another one like it.
 */
export const POST_SHAPES = [
  { id: 'guest-quote', label: 'Guest quote', head: 'a guest review' },
  { id: 'room-tour', label: 'Room tour', head: 'a room tour' },
  { id: 'before-after', label: 'Before / after', head: 'before and after' },
  { id: 'amenity', label: 'Amenity spotlight', head: 'an amenity spotlight' },
  { id: 'promote-dates', label: 'Promote dates', head: 'promote open dates' },
  { id: 'area-guide', label: 'Area guide', head: 'an area guide' },
  { id: 'behind', label: 'Behind the scenes', head: 'behind the scenes' },
  { id: 'caption', label: 'Just the caption', head: 'the photos as they are' },
] as const;
export type PostShapeId = (typeof POST_SHAPES)[number]['id'];

/** The shape a brief was made in, or null for a brief the host wrote in their own words. */
export function shapeOfBrief(brief: string): PostShapeId | null {
  const head = brief.trim().toLowerCase().slice(0, 40);
  if (!head) return null;
  return POST_SHAPES.find((s) => head.startsWith(s.head))?.id ?? null;
}

export function shapeLabel(id: string | null): string | null {
  return POST_SHAPES.find((s) => s.id === id)?.label ?? null;
}
